export default __webpack_public_path__ + "static/media/logo_pointShop.14c48c64.png";